import { render } from "./BuildPackagesPopup.vue?vue&type=template&id=222094cc&scoped=true&ts=true"
import script from "./BuildPackagesPopup.vue?vue&type=script&lang=ts"
export * from "./BuildPackagesPopup.vue?vue&type=script&lang=ts"

import "./BuildPackagesPopup.vue?vue&type=style&index=0&id=222094cc&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222094cc"]])

export default __exports__